/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

export default {
  path: '/salondb',
  name: 'salondb',
  children: [
    {
      path: '/',
      name: 'salondb-index',
      load: () => import(/* webpackChunkName: 'salondb' */ './default'),
    },
    {
      path: '/edit',
      name: 'salondb-edit',
      load: () => import(/* webpackChunkName: 'salondb' */ './edit'),
    },
    {
      path: '/merge',
      name: 'salondb-merge',
      load: () => import(/* webpackChunkName: 'salondb' */ './merge'),
    },
    {
      path: '/unmerge',
      name: 'salondb-unmerge',
      load: () => import(/* webpackChunkName: 'salondb' */ './unmerge'),
    },
    {
      path: '/points',
      name: 'salondb-points',
      load: () => import(/* webpackChunkName: 'salondb' */ '../salondb/points'),
    },
    {
      path: '/orders',
      name: 'salondb-orders',
      load: () => import(/* webpackChunkName: 'salondb' */ '../salondb/orders'),
    },
    {
      path: '/order/:id',
      name: 'salondb-order-detail',
      load: () =>
        import(/* webpackChunkName: 'salondb' */ '../salondb/order-detail'),
    },
    {
      path: '/:id',
      name: 'salondb-dashboard',
      load: () => import(/* webpackChunkName: 'salondb' */ './dashboard'),
    },
  ],
  action({ next, store, url }, { siteId }) {
    const state = store.getState();
    const modules =
      (((state.session || {}).USER_DATA || {}).group || {}).modules || [];
    if (!modules.includes('salondb')) {
      return {
        redirect: `/${siteId}/forbidden?redirect=${encodeURIComponent(
          url || '',
        )}`,
      };
    }
    return next();
  },
};



// WEBPACK FOOTER //
// ./src/routes/client/site/salondb/index.js